import bus, { EVENTS } from './bus';

export default class Crop extends PIXI.Graphics {
  constructor(crop, viewport, loader, skuList, isReversed = false, params) {
    super();

    this.crop = crop;
    this.viewport = viewport;
    this.loader = loader;
    this.skuList = skuList;
    this.isReversed = isReversed;

    this.is_selected = false;

    this.interactive = true;
    this.cursor = 'pointer';

    this.reference = params.reference;
    this.referenceImageHeight = params.referenceImageHeight;
    this.globalBoundariesAvailable = params.global_boundaries_available;

    this.listenBusEvents();

    if (this.crop.global_boundaries && this.globalBoundariesAvailable) {
      const { global_boundaries } = this.crop;

      this.rect_width = global_boundaries.bottom_right.x - global_boundaries.top_left.x;
      this.rect_height = global_boundaries.bottom_right.y - global_boundaries.top_left.y;

      this.rect_y = parseFloat(global_boundaries.top_left.y);
      this.rect_x = parseFloat(global_boundaries.top_left.x);
    } else if (this.crop.boundaries && this.reference) {
      // the reference image is scaled 5x, for the scale of crop boundaries
      const { width: scaledSceneWidth, height: scaledSceneHeight } = this.viewport.children[0];

      if (this.referenceImageHeight < 600) {
        const scaled_x = scaledSceneWidth / (scaledSceneWidth / 5);
        const scaled_y = scaledSceneHeight / (scaledSceneHeight / 5);

        const { boundaries } = this.crop;

        this.rect_width = ((boundaries.bottom_right.x) * scaled_x) - ((boundaries.top_left.x) * scaled_x);
        this.rect_height = ((boundaries.bottom_right.y) * scaled_y) - ((boundaries.top_left.y) * scaled_y);

        this.rect_y = parseFloat((boundaries.top_left.y * scaled_y));
        this.rect_x = parseFloat((boundaries.top_left.x * scaled_x));
      } else {
        const scaled_x = scaledSceneWidth / (scaledSceneWidth / 1);
        const scaled_y = scaledSceneHeight / (scaledSceneHeight / 1);

        const { boundaries } = this.crop;

        this.rect_width = ((boundaries.bottom_right.x) * scaled_x) - ((boundaries.top_left.x) * scaled_x);
        this.rect_height = ((boundaries.bottom_right.y) * scaled_y) - ((boundaries.top_left.y) * scaled_y);

        this.rect_y = parseFloat((boundaries.top_left.y * scaled_y));
        this.rect_x = parseFloat((boundaries.top_left.x * scaled_x));
      }
    } else if (this.crop.rectified_boundaries) {
      const { rectified_boundaries } = this.crop;

      this.rect_width = rectified_boundaries.bottom_right.x - rectified_boundaries.top_left.x;
      this.rect_height = rectified_boundaries.bottom_right.y - rectified_boundaries.top_left.y;

      this.rect_y = parseFloat(rectified_boundaries.top_left.y);
      this.rect_x = parseFloat(rectified_boundaries.top_left.x);
    } else if (this.crop.boundaries) {
      const { boundaries } = this.crop;

      this.rect_width = boundaries.bottom_right.x - boundaries.top_left.x;
      this.rect_height = boundaries.bottom_right.y - boundaries.top_left.y;

      this.rect_y = parseFloat(boundaries.top_left.y);
      this.rect_x = parseFloat(boundaries.top_left.x);
    }

    if (this.isReversed) {
      const { width: scaledSceneWidth } = this.viewport.children[0];

      this.rect_x = (this.rect_x * -1) + scaledSceneWidth - this.rect_width;
    }

    this.renderRect();
  }

  getLineWidth = () => {
    const baseWidth = this.is_selected ? 12 : 3;
    const lineWidth = baseWidth / this.viewport.scale.x;

    return lineWidth < 0.5 ? 0.5 : lineWidth;
  }

  renderRect() {
    const {
      rect_x: x,
      rect_y: y,
      rect_width: width,
      rect_height: height
    } = this;

    let realogramLineColor;
    let planogramLineColor;
    let lineColor;

    if (!bus.viewRecognitionResult) {
      bus.selectedLegends.forEach((legend) => {
        if (!this.reference) {
          switch (legend.id) {
            case 'misplaced':
              if (this.crop.is_misplacedRealogram) {
                realogramLineColor = legend.line_color;
              }
              break;
            case 'missing':
              if (this.crop.is_missingRealogram) {
                realogramLineColor = legend.line_color;
              }
              break;
            case 'excess':
              if (this.crop.is_excessRealogram) {
                realogramLineColor = legend.line_color;
              }
              break;
            default:
              break;
          }
        } else {
          switch (legend.id) {
            case 'missing':
              if (!this.crop.is_out_of_stockPlanogram && this.crop.is_missingPlanogram) {
                planogramLineColor = legend.line_color;
              }
              break;
            case 'out_of_stock':
              if (this.crop.is_out_of_stockPlanogram) {
                planogramLineColor = legend.line_color;
              }
              break;
            case 'misplaced':
              if (this.crop.is_misplacedPlanogram) {
                planogramLineColor = legend.line_color;
              }
              break;
            case 'excess':
              if (this.crop.is_excessPlanogram) {
                planogramLineColor = legend.line_color;
              }
              break;
            default:
              break;
          }
        }
      });
    } else {
      bus.selectedClasses.forEach((selected) => {
        switch (selected.id) {
          case 'competitor_sku':
            if (this.crop.is_competitor) {
              lineColor = selected.line_color;
            }

            break;
          case 'sku':
            if (this.crop.is_sku && !this.crop.is_competitor) {
              lineColor = selected.line_color;
            }

            break;
          case 'other_classes':
            if ((this.crop.is_meta || this.crop.is_nonSku) && !this.crop.text) {
              lineColor = selected.line_color;
            }

            break;
          case 'price_tag':
            if (this.crop.class.type === 'tag' && this.crop.text) {
              lineColor = selected.line_color;
            }

            break;
          default:
            break;
        }
      });
    }

    this.clear();
    this.removeChildren();

    const isCropInList = !!bus.updatedSkuList.find(item => (item.id.toString() === this.crop.class.id));

    if (this.reference && planogramLineColor && isCropInList) {
      this.fillAndDrawCrop(planogramLineColor, x, y, width, height);
    }

    if (this.reference && planogramLineColor && ((this.crop.is_unrecognized || this.crop.is_meta || this.crop.is_nonSku) && !this.crop.text) && !bus.isFilterSelected) {
      this.fillAndDrawCrop(planogramLineColor, x, y, width, height);
    }

    if (bus.viewRecognitionResult && lineColor && (isCropInList || (this.crop.class.type === 'tag' && this.crop.text) || (((this.crop.is_unrecognized || this.crop.is_meta || this.crop.is_nonSku) && !this.crop.text) && !bus.isFilterSelected))) {
      this.fillAndDrawCrop(lineColor, x, y, width, height);
    }

    // Add sku images
    if (this.crop.image_url && !bus.viewRecognitionResult && (isCropInList || (this.crop.is_unrecognized && !bus.isFilterSelected))) {
      this.loader.load((_, resources) => {
        const { texture } = resources[this.crop.crop_id];

        this.projection_sprite = new PIXI.projection.Sprite2d(texture);

        if (realogramLineColor) {
          const graphics = new PIXI.Graphics();

          graphics.beginFill(0xffffff, 0.1);
          graphics.lineStyle(9, realogramLineColor, 1, 1);
          graphics.drawRoundedRect(this.projection_sprite.x, this.projection_sprite.y, this.projection_sprite.width, this.projection_sprite.height, 4);
          graphics.endFill();

          if (bus.isFilledCrop) {
            graphics.beginFill(realogramLineColor, 0.7);
            graphics.lineStyle(9, realogramLineColor, 1, 0);
            graphics.drawRoundedRect(this.projection_sprite.x, this.projection_sprite.y, this.projection_sprite.width, this.projection_sprite.height, 4);
            graphics.endFill();
          }

          this.projection_sprite.addChild(graphics);
        }

        // center of bounding box
        const cx = (x + width / 2);
        const cy = (y + height / 2);

        const ratio = this.projection_sprite.width / this.projection_sprite.height;
        const constant = 70;

        if (this.projection_sprite.width >= this.projection_sprite.height) {
          this.projection_sprite.width = constant * 1 / this.viewport.scale.x;
          this.projection_sprite.height = constant * (1 / ratio) * 1 / this.viewport.scale.y;
        } else {
          this.projection_sprite.height = constant * 1 / this.viewport.scale.y;
          this.projection_sprite.width = constant * ratio * 1 / this.viewport.scale.x;
        }

        this.projection_sprite.x = cx - (this.projection_sprite.width / 2);
        this.projection_sprite.y = cy - (this.projection_sprite.height / 2);

        this.addChildAt(this.projection_sprite, 0);
      });
    }

    if (this.crop.image_url && bus.viewRecognitionResult && (this.crop.is_unrecognized && !bus.isFilterSelected)) {
      this.loader.load((_, resources) => {
        const { texture } = resources[this.crop.crop_id];

        this.projection_sprite = new PIXI.projection.Sprite2d(texture);

        // center of bounding box
        const cx = (x + width / 2);
        const cy = (y + height / 2);

        const ratio = this.projection_sprite.width / this.projection_sprite.height;
        const constant = 70;

        if (this.projection_sprite.width >= this.projection_sprite.height) {
          this.projection_sprite.width = constant * 1 / this.viewport.scale.x;
          this.projection_sprite.height = constant * (1 / ratio) * 1 / this.viewport.scale.y;
        } else {
          this.projection_sprite.height = constant * 1 / this.viewport.scale.y;
          this.projection_sprite.width = constant * ratio * 1 / this.viewport.scale.x;
        }

        this.projection_sprite.x = cx - (this.projection_sprite.width / 2);
        this.projection_sprite.y = cy - (this.projection_sprite.height / 2);

        this.addChildAt(this.projection_sprite, 0);
      });
    }

    if (bus.selectedMisplacedSkuId && !this.reference) {
      const isCropSelected = bus.selectedMisplacedSkuId === this.crop.class.id && this.crop.is_misplacedRealogram;

      if (isCropSelected) {
        const selectedCrop = bus.misplacedList.planogram.find(item => item.class.id === this.crop.class.id);
        if (selectedCrop) {
          const { bottom_right, top_left } = selectedCrop.global_boundaries;
          // middle of start point
          const middle_x = x + width / 2;
          const middle_y = y + height / 2;
          const state = {
            stroke: 6,
            color: 0x6EFFF1,
            fill: 0x0,
            x1: middle_x,
            y1: middle_y,
            dashLength: 8,
            spaceLength: 8
          };
          this.lineStyle(this.getLineWidth(), state.color);

          // middle of end point
          const planogramCropMiddlePoint = this.findCenterPointOfCrop(bottom_right, top_left);
          state.x2 = planogramCropMiddlePoint.x;
          state.y2 = planogramCropMiddlePoint.y;
          this.drawDash(
            this,
            state.x1,
            state.y1,
            state.x2,
            state.y2,
            state.dashLength,
            state.spaceLength
          );
        }
      } else {
        this.visible = false;
      }
    } else {
      this.visible = true;
    }
  }

  fillAndDrawCrop(lineColor, x, y, width, height) {
    if (bus.isFilledCrop) {
      this.beginFill(lineColor, 0.7);
    } else {
      this.beginFill(0xfffff, 0.01);
    }
    this.lineStyle(this.getLineWidth(), lineColor, 1, 0);
    this.drawRoundedRect(x, y, width, height, 2);
    this.endFill();
  }

  mouseover() {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.showToolTip();
    }, 450);
  }

  touchstart() {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.showToolTip();
    }, 450);
  }

  touchend() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyToolTip();
  }

  mouseout() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyToolTip();
  }

  click() {
    this.showMisplacedCropPlanogramPlacement();
  }

  getCropWithBounds() {
    return {
      bounds: this.getBounds(),
      crop: this.crop
    };
  }

  destroyToolTip = () => {
    if (!bus.selected_crop) {
      bus.$emit(EVENTS.DESTROY_TOOLTIP);
    }
  }

  showToolTip() {
    if (!bus.selected_crop) {
      bus.$emit(EVENTS.SHOW_TOOL_TIP, { crop: this.getCropWithBounds(), reference: this.reference });
    }
  }

  tap() {
    if (this.crop.is_sku) {
      bus.$emit('CROP_TAPPED', this.crop);
    }

    this.showMisplacedCropPlanogramPlacement();
  }

  drawDash(target, x_1, y_1, x_2, y_2, dashLength = 5, spaceLength = 5, arrowLength = 15, arrowAngleInRadians = 0.55) {
    let x1 = x_1;
    const x2 = x_2;
    let y1 = y_1;
    const y2 = y_2;
    const x = x2 - x1;
    const y = y2 - y1;
    let hyp = Math.sqrt((x) * (x) + (y) * (y));
    const units = hyp / (dashLength + spaceLength);
    const dashSpaceRatio = dashLength / (dashLength + spaceLength);
    const dashX = (x / units) * dashSpaceRatio;
    const spaceX = (x / units) - dashX;
    const dashY = (y / units) * dashSpaceRatio;
    const spaceY = (y / units) - dashY;
    target.beginFill(0x6EFFF1, 1);
    target.moveTo(x1, y1);

    while (hyp > 0) {
      x1 += dashX;
      y1 += dashY;
      hyp -= dashLength;
      if (hyp < 0) {
        x1 = x2;
        y1 = y2;
      }
      target.lineTo(x1, y1);
      x1 += spaceX;
      y1 += spaceY;
      target.moveTo(x1, y1);
      hyp -= spaceLength;
    }

    const [x2s, y2s, x3, y3, x4, y4] = this.calculateArrowCoordinates(x1, y1, x2, y2, arrowLength, arrowAngleInRadians);

    const angleInRadians = Math.PI / 3.2;
    const cosAngle = Math.cos(angleInRadians);
    const sinAngle = Math.sin(angleInRadians);

    const newX2 = cosAngle * (x2s - x1) - sinAngle * (y2s - y1) + x1;
    const newY2 = sinAngle * (x2s - x1) + cosAngle * (y2s - y1) + y1;

    const newX3 = cosAngle * (x3 - x1) - sinAngle * (y3 - y1) + x1;
    const newY3 = sinAngle * (x3 - x1) + cosAngle * (y3 - y1) + y1;

    const newX4 = cosAngle * (x4 - x1) - sinAngle * (y4 - y1) + x1;
    const newY4 = sinAngle * (x4 - x1) + cosAngle * (y4 - y1) + y1;

    target.moveTo(newX2, newY2);
    target.lineTo(newX3, newY3);
    target.lineTo(newX4, newY4);
    target.closePath();

    this.endFill();
  }

  // eslint-disable-next-line class-methods-use-this
  calculateArrowCoordinates(x1, y1, x2, y2, arrowLength, arrowAngle) {
    const angle = Math.atan2(y2 - y1, x2 - x1);
    const x3 = x2 - arrowLength * Math.cos(angle - arrowAngle);
    const y3 = y2 - arrowLength * Math.sin(angle - arrowAngle);
    const x4 = x2 - arrowLength * Math.cos(angle + arrowAngle);
    const y4 = y2 - arrowLength * Math.sin(angle + arrowAngle);

    return [x2, y2, x3, y3, x4, y4];
  }

  // eslint-disable-next-line class-methods-use-this
  findCenterPointOfCrop(bottom_right, top_left) {
    return {
      x: (bottom_right.x + top_left.x) / 2,
      y: (bottom_right.y + top_left.y) / 2
    };
  }

  showMisplacedCropPlanogramPlacement() {
    if (this.crop.is_misplacedRealogram) {
      bus.selectedMisplacedSkuId = (bus.selectedMisplacedSkuId === this.crop.class.id) ? null : this.crop.class.id;
      bus.$emit(EVENTS.CHANGE_CROP_VISIBILITY);
    }
  }

  listenBusEvents() {
    bus.$on(EVENTS.RENDER_SELECTED_CROP, (crop) => {
      if (crop.crop_id === this.crop.crop_id) {
        this.is_selected = !this.is_selected;
      } else {
        this.is_selected = false;
      }

      this.renderRect();
    });

    bus.$on(EVENTS.ZOOM_END, () => this.renderRect());
    bus.$on(EVENTS.RE_RENDER_CROP, () => this.renderRect());
    bus.$on(EVENTS.CHANGE_CROP_VISIBILITY, () => this.renderRect());
  }
}
